import { HTMLEditor } from './HTMLEditor';

export default HTMLEditor;
